/*
 * 戒导航 · 头像审核 —— 前台扩展声明
 *
 * 设计依据：doc/内容二次复核队列设计方案.md（v1.1）§4.8。
 *
 * 这里注册两样东西，**缺一不可**：
 *
 * ── ① 前端模型 secondReviews（Store）─────────────────────────────────────────
 *   ★ 为什么必须注册（漏了它 → 通知面板一片空白，且不报错）：
 *     本模块的通知 subject 是「二次复核记录行」（见
 *     JieDH\AvatarGuard\Notify\ContentViolationBlueprint::getSubject()），
 *     通知接口的关系是 relationships.subject = { type: 'secondReviews', id: 'N' }。
 *     而 Flarum 前端的本地仓库 app.store 只接收**已注册的 type**：
 *       vendor/flarum/core/js/src/common/Store.ts → pushObject()
 *         if (!this.models[data.type]) { ... return null; }   // ← 未注册：资源被静默丢弃
 *     未注册 ⇒ notification.subject() 得到 undefined ⇒
 *       vendor/flarum/core/js/src/forum/components/NotificationList.js:82
 *         if (typeof subject === 'undefined') return;         // ← 整条通知被丢弃
 *     这一坑与本项目 packages/review 的「处置回执」完全同源（见其 models/ModerationReceipt.ts
 *     头部注释），packages/review 已踩过一次，此处照抄其解法。
 *     type 名 'secondReviews' 必须与后端
 *     JieDH\AvatarGuard\Api\Resource\SecondReviewResource::type() 完全一致。
 *
 * ── ② 通知渲染组件（Notification）────────────────────────────────────────────
 *   核心的渲染逻辑是（vendor/flarum/core/js/src/forum/components/NotificationType.tsx）：
 *       const C = app.notificationComponents[notification.contentType()];
 *       return C ? <C notification={...} /> : null;
 *   取不到组件就**静默 return null**（不报错、不显示）—— 新通知类型必须自己注册。
 *   第一个参数（通知类型标识）必须与后端
 *   JieDH\AvatarGuard\Notify\ContentViolationBlueprint::getType() 的返回值完全一致。
 *
 * 注册写法照抄官方 flarum/likes 与本项目 packages/review/js/src/forum/extend.ts。
 */
import Extend from 'flarum/common/extenders';
import SecondReview from './models/SecondReview';
import ContentViolationNotification from './components/ContentViolationNotification';
export default [
// ① 二次复核记录模型：让通知接口的 subject 关系能被前端 store 接收
new Extend.Store().add('secondReviews', SecondReview),
// ② 内容违规处置通知卡片（头像被二次复核驳回后发给用户的站内消息）
new Extend.Notification().add('jiedhContentViolation', ContentViolationNotification)];